import { z } from "zod";

export const OrganizationFactNodeContentSchema = z.object({
  nodeType: z.literal("organization"),
  version: z.literal("1"),

  name: z.string().min(1).max(128),
  website: z.url().optional(),
});
